import React, { useEffect, useState } from "react";
import {
  DatePicker,
  DatePickerInput,
  Input,
  ReactSelector,
  TextArea,
  dateFormat,
  searchDateFormat,
  timeFormatWithSecond,
} from "../../components/Form";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ModalBox from "../../components/modal/ModalBox";
import {
  addNotificationApi,
  fathUserApi,

} from "../../services/notification";
import toast from "react-hot-toast";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "react-select";
import { catchMessage, elseMessage } from "../../comman/Message";

const AddNotification = ({ show, close, listing, setAddModalShow }) => {
  const [input, setInput] = useState({
    title: "",
    description: "",
    user: "",
    userType: "",
    sendNotification: "",
    timeZone:""
  });
  const [timeZoneValue, setTimeZoneValue] = useState({});
  const [error, setError] = useState({});
  const [schedulerError, setSchedulerError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Send Now");
  // const [allUser, setAllUser] = useState([])
  const [scheduleModal, setScheduleModal] = useState(false);
  const [date, setDate] = useState("");
  const [selectTime, setSelectTime] = useState({});
  console.log(selectTime, "selectTime")
  const currentTime = dayjs().startOf("minute");
  const [user, setUser] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userNotificationType, setUserNotificationType] = useState(false);
  const items = [
    { label: 'Eastern Time (US)', value: 'America/New_York' },
    { label: 'Central Time (US)', value: 'America/Chicago' },
    { label: 'Mountain Time (US)', value: 'America/Denver' },
    { label: 'Pacific Time (US)', value: 'America/Los_Angeles' },
    { label: 'Alaska Time (US)', value: 'America/Anchorage' },
    { label: 'Hawaii-Aleutian Time (US)', value: 'Pacific/Honolulu' },
    { label: 'Indian Standard Time (India)', value: 'Asia/Kolkata' },
    { label: 'Irish Time (Ireland)', value: 'Europe/Dublin' },
    { label: 'British Time (UK)', value: 'Europe/London' },
    { label: 'Newfoundland Time (Canada)', value: 'America/St_Johns' },
    { label: 'Atlantic Time (Canada)', value: 'America/Halifax' },
    { label: 'Eastern Time (Canada)', value: 'America/Toronto' },
    { label: 'Central Time (Canada)', value: 'America/Winnipeg' },
    { label: 'Mountain Time (Canada)', value: 'America/Edmonton' },
    { label: 'Pacific Time (Canada)', value: 'America/Vancouver' },
    { label: 'Pacific Time (Mexico)', value: 'America/Tijuana' },
    { label: 'Mountain Time (Mexico)', value: 'America/Hermosillo' },
    { label: 'Central Time (Mexico)', value: 'America/Mexico_City' },
    { label: 'Eastern Time (Mexico, Quintana Roo)', value: 'America/Cancun' },

   
  ];
  //---------message-vaidation------------
  const validation = () => {
    let errorMessage = {};
    let status = true;

    if (input?.sendNotification === "2") {
      if (user?.length === 0) {
        errorMessage["select"] = "Please choose user";
        status = false;
      }
    }
    // if (!input.sendNotification) {
    //     toast.error("Please choose send notification")
    //     status = false;
    // }
    if (input.title && input.description) {
      if (!input.sendNotification) {
        toast.error("Please choose send notification All or Selected");
        status = false;
      }
    }
    if (!input.title) {
      errorMessage["title"] = "Please enter title ";
      status = false;
    }
    if (!input.description) {
      errorMessage["description"] = "Please enter description";
      status = false;
    }
    setError(errorMessage);
    return status;
  };

  //---------schduler-vaidation------------
  const timeValidation = () => {
    let errorMessage = {};
    let status = true;

    if (!date) {
      errorMessage["Date"] = "Please select date";
      status = false;
    }
    if (!selectTime?.$d) {
      errorMessage["time"] = "Please select time";
      status = false;
    }
    if (!timeZoneValue) {
      errorMessage["timeZole"] = "Please select timeZone";
      status = false;
    }
    setSchedulerError(errorMessage);
    return status;
  };
  //------------------onChange-input-value---------------------------
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "title" || name === "description") {
      // Allow only letters and spaces for the name, and remove leading spaces
      const cleanedName = value.replace(/^[ ]+/g, "").replace(/\s+/g, " ");
      setInput({ ...input, [name]: cleanedName });
    } else {
      setInput({ ...input, [name]: value });
    }
  };

  //-----------------handle-select-user---------------------
  const handleSelectUser = (userId) => {
    // console.log("userId",userId)
    setUser(userId);
  };
  //----------------message-modal-close--------------------------
  const modalClose = () => {
    setInput({
      title: "",
      description: "",
      user: "",
      userType: "",
      sendNotification: "",
    });
    setUser([]);
    setError({});
    close();
  };
  //-----------------scheduler-modal-close--and-message-modal-open---------------------
  const scheduleModalClose = () => {
    setAddModalShow(true);
    // setInput({ title: input.title, description: input.description, user: input.user, userType: input.userType, });
    setInput(input);
    // setAllUser(allUser);
    setSchedulerError({});
    setSelectTime({});
    setDate("");
    setScheduleModal(false);
    setUserNotificationType(false);
  };

  //-----------------scheduler-modal-open--and-message-modal-close---------------------
  const schedulerModleOpen = () => {
    if (validation()) {
      setScheduleModal(true);
      setAddModalShow(false);
      setUserNotificationType(true);
    }
  };

  //-----------------scheduler-message-send---------------------
  const schedulerSubmit = () => {
    if (timeValidation()) {
      AddNotificationData();
    }
  };
  console.log(timeFormatWithSecond(selectTime?.$d), "timeFormatWithSecond(selectTime?.$d)")
  //--------------send-notification-category------------------------
  const AddNotificationData = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        let finalData = {
          // userType: input.user,
          title: input.title,
          // type: userNotificationType,
          message: input.description,
          isSchedule: userNotificationType,
        };
        // Check if selectRadio is "1" (Select User or Provider)
        if (input?.sendNotification === "2") {
          finalData = {
            ...finalData,
            users: user.map((data) => data.value),
            // users: user[0]?.value
          };
        }
        if (input?.sendNotification === "1") {
          finalData = {
            ...finalData,
            users: userList.map((data) => data.value),
            // scheduleDate: searchDateFormat(date),
            // scheduleTime: timeFormatWithSecond(selectTime?.$d),
          };
        }
        if (userNotificationType === true) {
          finalData = {
            ...finalData,
            timeZone: timeZoneValue.value, // <-- append here
            scheduledDate: searchDateFormat(date),
            // scheduleTime: timeFormatWithSecond(selectTime?.$d),
            scheduleTime: timeFormatWithSecond(selectTime?.$d),

          };
        }
        // console.log("finalData", finalData)
        const res = await addNotificationApi(finalData);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          modalClose();
          setScheduleModal(false);
          setSelectTime({});
          setDate("");
          listing();
          setUserNotificationType(false);
          buttonLoader(false);
          setTimeZoneValue({})
        } else {
          toast.error(res.data.message);
          buttonLoader(false);
        }
      } catch (e) {
        toast.error(e.message);
        buttonLoader(false);
      }
    }
  };
  //--------------get-list-dropDown-user------------------------
  const fathUser = async (search = "") => {
    try {
      setUserList([]);
      const res = await fathUserApi(search);
      if (res.data?.status === 200) {
        const data = res?.data?.data?.list;
        const allList = data.map(({ id, userName }) => ({
          label: userName,
          value: id,
        }));
        setUserList(allList || []);
      } else {
        setUserList([]);
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  useEffect(() => {
    if (show) {
      fathUser();
    }
  }, [show]);
  return (
    <>
      {/* --------------send-Notification-modal------------------------- */}
      <ModalBox
        status={show}
        onClose={modalClose}
        title={"Add Notification"}
        closeIcon
        custom
        customizedFooter={
          <div className="">
            <button
              className="Schedule_btn"
              ref={buttonref}
              onClick={schedulerModleOpen}
            >
              {" "}
              Schedule now
            </button>
            <button
              className="btn_size "
              ref={buttonref}
              onClick={AddNotificationData}
            >
              {" "}
              Send Now
            </button>
          </div>
        }
      >
        <div>
          <div className="row">
            {/* <div className="col-6">
                            <div className="form-group mb-2 ">
                                <label htmlFor="">Select User Type</label>
                                <RadioGroup row

                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="user"
                                    value={input?.user || ""}
                                    onChange={handleChange}
                                >

                                    <FormControlLabel value="seller" control={<Radio />} label="Seller" />
                                    <FormControlLabel value="bidder" control={<Radio />} label="Bidder" />

                                </RadioGroup>
                            </div>
                        </div> */}
            {/* if user select to send message then show  */}
            <div className="col-6">
              <div className="form-group mb-2 ">
                <label htmlFor="">Send Notification</label>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="sendNotification"
                  value={input?.sendNotification || ""}
                  onChange={handleChange}
                >
                  <FormControlLabel value="1" control={<Radio />} label="All" />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="Single"
                  />
                </RadioGroup>
              </div>
            </div>
          </div>
          {input?.sendNotification === "2" && (
            <div className="col-sm-12 col-lg-12 col-md-12">
              <div className="form-group mb-1 mb-1">
                <label className="mb-1">
                  {" "}
                  Select User<span className="text-danger">*</span>
                </label>
                <Select
                  name="select"
                  className={`${error.select ? "form-control" : ""} ${!user.length && error.select && "is-invalid"
                    }`}
                  value={user}
                  options={userList}
                  isMulti
                  onChange={handleSelectUser}
                />
              </div>
              {error.select && (
                <div className="invalid-feedback d-block">{error.select}</div>
              )}
            </div>
          )}

          <div className="form-group mb-2">
            <Input
              type="text"
              name="title"
              value={input?.title || ""}
              onChange={handleChange}
              placeholder="Enter title "
              className="form-control"
              label="Title "
              optionalText="(max 25 alphabets)"
              error={error.title}
              maxLength={25}
            />
          </div>

          <div className="form-group mb-2">
            <TextArea
              type="text"
              name="description"
              value={input?.description || ""}
              onChange={handleChange}
              placeholder="Enter  description"
              className={`form-control `}
              label={"Description"}
              optionalText="(max 100 alphabets)"
              error={error.description}
              maxLength={100}
            />
          </div>
        </div>
      </ModalBox>

      {/* --------------Scheduler-Notification-modal------------------------- */}
      <ModalBox
        status={scheduleModal}
        onClose={scheduleModalClose}
        title={"Add Schedule"}
        closeIcon
        custom
        className="customeModal"
        customizedFooter={
          <button
            className="btn_size "
            ref={buttonref}
            onClick={schedulerSubmit}
          >
            {" "}
            Schedule now
          </button>
        }
      >
           <div className="col-sm-12 col-lg-12 col-md-12">
              <div className="form-group mb-1 mb-1">
                {/* <label className="mb-1">
                  {" "}
                  <span className="text-danger">*</span>
                </label> */}
                <ReactSelector
                  label="Select Time Zone"
                  name="timeZone"
                  value={timeZoneValue || ""}
                  className={`${error.timeZone ? "form-control" : ""} ${!user.length && error.timeZone && "is-invalid"
                  }`}
                  option={items}
                  onChange={(selected) => {
                    setTimeZoneValue(selected);
                    setInput((prev) => ({
                      ...prev,
                      timeZone: selected?.value || "", // ✅ append only value part
                    }));
                  }}
                  error={error?.timeZone}
                  placeholder={"Select TimeZone"}
                />
                {/* <select
                  name="select"
                  onChange={(e) => setTimeZoneValue(e.target.value)}
                  value={timeZoneValue}
                  className={`${error.timeZone ? "form-control" : ""} ${!user.length && error.timeZone && "is-invalid"
                    }`}
                  >
                  <option value="">Select Time Zone</option> */}
                  {/* {items.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))} */}
                  {/* </select> */}
                  </div>
              {error.timeZoneValue && (
                <div className="invalid-feedback d-block">{error.timeZoneValue}</div>
              )}
            </div>
        <div className="form-group width-custm">
          <DatePickerInput
            label={"Select Date"}
            className="form-control password"
            name="Date"
            selected={date || ""}
            placeholder="Select Date"
            autoComplete="off"
            onChange={(date) => setDate(date)}
            minDate={Date.now()}
            error={schedulerError.Date}
          />
        </div>
        <div className="form-group custm-form-time">
          <label className="col-form-label">Select Time</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              // className="form-control"
              className={`form-control p-0 error_icon_show ${!selectTime?.$d && schedulerError?.time && "is-invalid"
                }`}
              ampm={false}
              name="time"
              minTime={
                date && dateFormat(date) > dateFormat(Date.now())
                  ? null
                  : currentTime
              }
              views={["hours", "minutes"]}
              value={selectTime}
              onChange={(date) => setSelectTime(date)}
            />
          </LocalizationProvider>
          {schedulerError?.time && (
            <p className={`invalid-feedback ${!selectTime?.$d && "d-block"}`}>
              {schedulerError?.time}
            </p>
          )}
        </div>
      </ModalBox>
    </>
  );
};

export default AddNotification;
